
import { createSelector } from 'reselect'

export const getIsAuthenticated = createSelector(state => state.auth.isAuthenticated, (isAuthenticated) => isAuthenticated)
